/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_card__book_min_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `Reservierung ab ${i.price}`
};

const en_poi_card__book_min_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `Booking starting at ${i.price}`
};

const es_poi_card__book_min_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `Reservar desde ${i.price}`
};

const fr_poi_card__book_min_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `Réserver à partir de ${i.price}`
};

const it_poi_card__book_min_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `Prenota da ${i.price}`
};

const nl_poi_card__book_min_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `Reserveren vanaf ${i.price}`
};

const pt_poi_card__book_min_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `Reservar a partir de ${i.price}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ price: NonNullable<unknown> }} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__book_min_price = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_card__book_min_price(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_card__book_min_price", locale)
	if (locale === "de") return de_poi_card__book_min_price(inputs)
	if (locale === "en") return en_poi_card__book_min_price(inputs)
	if (locale === "es") return es_poi_card__book_min_price(inputs)
	if (locale === "fr") return fr_poi_card__book_min_price(inputs)
	if (locale === "it") return it_poi_card__book_min_price(inputs)
	if (locale === "nl") return nl_poi_card__book_min_price(inputs)
	return pt_poi_card__book_min_price(inputs)
};